import { render, staticRenderFns } from "./PersonalDocumentsEditForm.vue?vue&type=template&id=f9d6f812&scoped=true"
import script from "./PersonalDocumentsEditForm.vue?vue&type=script&lang=js"
export * from "./PersonalDocumentsEditForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDocumentsEditForm.vue?vue&type=style&index=0&id=f9d6f812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d6f812",
  null
  
)

export default component.exports